import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClearDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -33.9785,
			y: -33.9785,
			width: 87.957,
			height: 87.957,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(16.99px)",
					clipPath: "url(#bgblur_0_21736_101033_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			"data-figma-bg-blur-radius": 33.9785,
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 20,
					height: 20,
					rx: 10,
					fill: "#2B313A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.771 6.22852L6.22835 13.7712",
					stroke: "white",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.771 13.771L6.22835 6.22835",
					stroke: "white",
					strokeWidth: 1.5
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_21736_101033_clip_path",
			transform: "translate(33.9785 33.9785)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				rx: 10
			})
		}) })
	]
});
export default SvgClearDark;
